import { createElement } from 'react';
import { BaseDialog } from './__internal__';
import { FullScreenDialogProps } from './types';
import { Toolbar } from '../Toolbar';
import { BusyStateIndicator } from '../BusyStateIndicator';
import { renderInlineCssVars, useDesignTokens } from '../../theme';
import { Flow } from '../Layouts/Flow';
import { createUseHtmlId } from '../../hooks/useHtmlId';
import { postfixTestId } from '../../util/testId';
import cx from 'classnames';
import cn from './FullScreenDialog.css.json';
import './FullScreenDialog.css';

const useHeaderId = createUseHtmlId('fullScreenDialog-header');

export const FullScreenDialog = (props: FullScreenDialogProps) => {
  const dialogHeaderId = useHeaderId();
  const role = props.role ?? 'dialog';

  const dt = useDesignTokens();
  const tokens = renderInlineCssVars(
    {
      'spacing-m': dt.spacing.core.m,
      'spacing-xl': dt.spacing.core.xl,
      'title-font-size-xl': dt.fontNova.size.xl,
      'title-font-weight-thick': dt.fontNova.weight.thick,
      'title-fg': dt.c.colorTextDefault,
      bg: dt.c.colorUiDark,
      'content-bg': dt.c.colorUiLight,
      'content-bd': dt.c.colorUiBorder,
    },
    'full-screen-dialog'
  );

  const renderFullScreenDialog = () => {
    return (
      <div
        className={cx(cn.container, props.className)}
        style={tokens}
        role={role}
        aria-labelledby={dialogHeaderId}
        aria-describedby={props.ariaDescribedBy}
        onKeyDown={props.onKeyDown}
      >
        <BusyStateIndicator
          {...props.busyStateIndicatorProps}
          fillParentContainer
          containerClassName={cn.containerInner}
        >
          <Flow orientation="vertical" spacing="xs">
            {props.breadCrumbs && props.breadCrumbs.length > 0 && (
              <Toolbar
                testId={postfixTestId(props.testId, '-breadcrumToolbar')}
                items={[
                  {
                    type: 'Breadcrumb',
                    orientation: 'HORIZONTAL',
                    values: props.breadCrumbs,
                    selectCrumb: props.onSelectBreadCrumbItem,
                  },
                  { type: 'ToolbarSpacer' },
                ]}
              />
            )}
            {props.renderHeaderToolbar(
              dialogHeaderId,
              props.breadCrumbs && props.breadCrumbs[props.breadCrumbs?.length - 1].values[0]
            )}
          </Flow>
          <div className={cn.contentArea}>{props.children}</div>
        </BusyStateIndicator>
      </div>
    );
  };

  return props.isOpen ? (
    <BaseDialog
      title=""
      isOpen={props.isOpen}
      renderLayout={renderFullScreenDialog}
      focusLockProps={props.focusLockProps}
    />
  ) : null;
};
